import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    tableRoot: {
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableCell-head": {
        background: "#DAF7FB"
      },
      "& .MuiCheckbox-root": {
        padding: 0
      },
      "& .MuiFormHelperText-root.Mui-error": {
        marginLeft: 0,
        fontFamily: "ScgFont, sans-serif",
        fontWeight: 400,
        fontSize: "1.1rem",
        lineHeight: "16px",
        color: theme.palette.scgPrimary.main
      },
      marginBottom: 20,
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderRight: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "none"
        }
      },
      "& .MuiTable-root": {
        overflowX: "auto",
        width: "auto",
        margin: "0 auto",
        "& .MuiTableCell-head": {
          borderTop: `2px solid ${theme.palette.info.main}`
        },
        "& .MuiTableBody-root > tr > td": {
          borderBottom: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-head:nth-child(-n+4)": {
          borderTop: `1px solid ${theme.palette.grey[300]}`
        }
      }
    },
    boxCheckBox: {
      "& .MuiCheckbox-root": {
        marginTop: "0.5rem"
      },
      display: "flex",
      flexDirection: "column"
    },
    tableHeader: {
      height: "78px"
    },
    delete: {
      fontStyle: "italic",
      fontSize: "14px",
      lineHeight: "22px",
      fontFamily: "ScgFont, sans-serif",
      textAlign: "center",
      color: "#FF0000",
      fontWeight: 400
    },
    header: {
      display: "flex",
      margin: "1.8rem 0",
      alignItems: "center",
      color: theme.palette.grey[900]
    },
    txtInputSelect: {
      "&>div": {
        fontWeight: 400
      }
    },
    responsiveTable: {
      overflowX: "hidden"
    },
    scrollAble: {
      overflowX: "unset"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 68% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 68% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "4px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      justifyContent: "start"
    },
    boxShadowTab: { filter: "drop-shadow(2px 0px 4px rgba(0, 0, 0, 0.25))" },
    tabB: {
      marginLeft: "-4rem"
    },
    active: {
      backgroundColor: theme.palette.info.main,
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    },
    z0: {
      zIndex: 0
    },
    z1: {
      zIndex: 1
    },
    notActive: {
      backgroundColor: theme.palette.grey[300],
      "& .MuiTypography-root": {
        color: "#000000"
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[400]
      }
    },
    body3: {
      fontFamily: "SCG",
      fontSize: "1.4rem",
      fontWeight: 400,
      lineHeight: "22px",
      color: theme.palette.grey[900]
    },
    svg: {
      marginRight: "1.2rem"
    },
    cellCheckBox: {
      width: "64px",
      minWidth: "64px",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      paddingRight: "0px !important"
    },
    checkBox: {
      padding: "10px"
    },
    selectField: {
      "& .MuiSelect-root": {
        padding: "0.4rem 1.2rem"
      },
      height: "3.2rem"
    },
    boxSearchInput: {
      "&>div": {
        width: "100%"
      },
      "& .MuiFormControl-root": {
        height: "35px",
        marginRight: "1rem"
      },
      "&>svg": {
        marginLeft: "0.5rem",
        cursor: "pointer"
      },
      display: "flex",
      alignItems: "center"
    },
    textFieldCustom: {
      "& .MuiOutlinedInput-input": {
        padding: "7px 16px"
      }
    },
    disabled: {
      pointerEvents: "none"
    },
    numberInput: {
      maxWidth: "112px"
    },
    noBorderRight: {
      borderRight: "0 !important"
    },
    borderLeft: {
      borderLeft: `1px solid ${theme.palette.grey[300]}`
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]} !important`
    },
    thDelivery: {
      background: "#E6F6F8 !important"
    },
    topBox: {
      position: "relative",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "35px",
      marginBottom: "-50px",
      height: "32px"
    },
    fixedBtn: {
      position: "fixed",
      right: 0
    },
    txtError: {
      marginLeft: 0,
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.1rem",
      lineHeight: "16px",
      color: theme.palette.scgPrimary.main,
      marginTop: "1rem"
    },
    ml10: {
      marginLeft: "1rem"
    },
    boxQuantity: {
      display: "flex",
      alignItems: "center"
    },
    nonDeleteTxt: {
      color: theme.palette.grey[500]
    },
    deleteBox: {
      display: "flex"
    },
    textQuantityPopup: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 700,
      fontSize: "1.8rem",
      lineHeight: "24px"
    },
    customCell: {
      height: "12px",
      padding: "0.8rem 1.2rem !important"
    },
    unlimited: {
      paddingLeft: "0 !important"
    },
    delivery: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.3rem",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      color: theme.palette.grey[900]
    },
    freezeCell: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 1
    },
    freezeCell1: {
      position: "sticky",
      left: 70,
      background: "inherit",
      zIndex: 1
    },
    freezeCell2: {
      position: "sticky",
      left: 160,
      background: "inherit",
      zIndex: 1
    },
    freezeCell3: {
      position: "sticky",
      left: 320,
      background: "inherit",
      zIndex: 1
    },
    freezeCell4: {
      position: "sticky",
      left: 640,
      zIndex: 1,
      background: `${theme.palette.background.default} !important`,
      borderTop: "0 !important"
    },
    quantityCell: {
      border: "0 !important",
      background: `${theme.palette.background.default} !important`,
      paddingLeft: "0 !important",
      paddingBottom: "0 !important"
    },
    boxSvg: {
      cursor: "pointer",
      maxWidth: "4rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:active": {
        background: "#EEEEEE",
        borderRadius: "4px",
        "& svg path": {
          stroke: theme.palette.grey[700]
        }
      },
      "&:hover": {
        "& svg path": {
          stroke: theme.palette.grey[700]
        }
      }
    },
    tabBox: { position: "absolute", left: 0, bottom: 0, display: "flex" },
    button: {
      padding: 6
    },
    buttonApply: {
      borderRadius: "4px",
      padding: "0.4rem 0.8rem",
      fontWeight: 400,
      fontSize: "1.2rem",
      lineHeight: "18px",
      background: "#009FB8",
      color: "white",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px",
      "&:hover, &:active": {
        color: "#009FB8",
        background: "#F2FAFB",
        outline: "1px solid #009FB8",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
      }
    },
    btnApplyOpen: {
      color: "#009FB8",
      background: "#F2FAFB",
      outline: "1px solid #009FB8",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
    },
    svgDatePicker: {
      marginRight: "0.8rem"
    },
    tableCellCenter: {
      "& > div": {
        textAlign: "center",
        justifyContent: "center"
      }
    }
  }),
  {
    name: "MaterialItemTab"
  }
);

export default useStyles;
